import React from 'react';
import {Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';

export function buildHelpMarkdownComponents() {
    return {
        h1: ({node, ...props}) => (
            <Typography variant="h4" fontWeight={700} sx={{mt: 2, mb: 1.5, color: 'primary.main'}} {...props} />
        ),
        h2: ({node, ...props}) => (
            <Typography variant="h5" fontWeight={600} sx={{mt: 2.5, mb: 1, pt: 1, borderTop: '1px solid', borderColor: 'divider'}} {...props} />
        ),
        h3: ({node, ...props}) => (
            <Typography variant="h6" fontWeight={600} sx={{mt: 2.5, mb: 1}} {...props} />
        ),
        h4: ({node, ...props}) => (
            <Typography variant="subtitle1" fontWeight={600} sx={{mt: 2, mb: 1}} {...props} />
        ),
        p: ({node, ...props}) => (
            <Typography variant="body1" sx={{mb: 1.5, lineHeight: 1.75, color: 'text.primary'}} {...props} />
        ),
        strong: ({node, ...props}) => (
            <Box component="strong" sx={{fontWeight: 700}} {...props} />
        ),
        ul: ({node, ...props}) => (
            <Box component="ul" sx={{pl: 3, mb: 2, '& li': {mb: 0.75}}} {...props} />
        ),
        ol: ({node, ...props}) => (
            <Box component="ol" sx={{pl: 3, mb: 2, '& li': {mb: 0.75}}} {...props} />
        ),
        li: ({node, ...props}) => (
            <Typography component="li" variant="body1" sx={{lineHeight: 1.7}} {...props} />
        ),
        hr: () => (
            <Box sx={{my: 3, borderBottom: '1px solid', borderColor: 'divider'}} />
        ),
        table: ({node, ...props}) => (
            <TableContainer component={Paper} variant="outlined" sx={{my: 2, overflowX: 'auto'}}>
                <Table size="small" {...props} />
            </TableContainer>
        ),
        thead: ({node, ...props}) => <TableHead {...props} />,
        tbody: ({node, ...props}) => <TableBody {...props} />,
        tr: ({node, ...props}) => <TableRow {...props} />,
        th: ({node, ...props}) => (
            <TableCell sx={{fontWeight: 700, bgcolor: 'grey.50', whiteSpace: 'nowrap'}} {...props} />
        ),
        td: ({node, ...props}) => (
            <TableCell sx={{verticalAlign: 'top', lineHeight: 1.6}} {...props} />
        ),
        em: ({node, ...props}) => (
            <Box component="em" sx={{fontStyle: 'italic', color: 'text.secondary'}} {...props} />
        ),
    };
}
